import { defineQuery, enterQuery } from "bitecs";
import { World } from "../threeMain";
import { Cube } from "../utils/components";
import { BoxGeometry, Mesh, MeshBasicMaterial, NeverCompare, Quaternion } from "three";
import { setObject3dComponent } from "./bit-object-system";

const cubeQuery = defineQuery([Cube])
const newCubeQuery = enterQuery(cubeQuery);

export function cubeSystem(world: World){
  newCubeQuery(world).forEach((eid: number) => {
    console.log("### cubeAdded")
    const geometry = new BoxGeometry( 1, 1, 1 );
    const material = new MeshBasicMaterial( { color: 0x00ffff } );
    const cube = new Mesh( geometry, material );
    world.scene.add(cube);
    setObject3dComponent(world, eid, cube);
  })
  cubeQuery(world).forEach((eid: number) => {
    const cube = world.eid2obj.get(eid)!;
    if(!cube) return;
    const rot = cube.rotation;
    let newVal = ( rot.x +0.025 );
    if(newVal > Math.PI*2) newVal = newVal - Math.PI;
    rot.set(newVal, newVal, rot.z)
    cube.updateMatrixWorld()
  })
}